// Versão do app - gerado automaticamente
export const APP_VERSION = '5.40'
export const BUILD_DATE = '15/05/2026, 00:16'
